import type { ReactNode } from 'react';
import type { SearchValueType, TypeOrArray } from '../common-interfaces';
import type { JsonData, JsonDataItem } from '../generic-types';

export const ContinuousScrollerComparisonType = {
  Contains: 0,
  Equals: 1,
  Between: 2,
  LessThan: 3,
  LessThanEqualTo: 4,
  GreaterThan: 5,
  GreaterThanEqualTo: 6,
} as const;
export type ContinuousScrollerComparisonType =
  (typeof ContinuousScrollerComparisonType)[keyof typeof ContinuousScrollerComparisonType];

export interface ContinuousScrollerFilter {
  scrollerId: string | number;
  field: string;
  value: SearchValueType | Array<SearchValueType>;
  comparison?: ContinuousScrollerComparisonType;
  text?: string | string[];
  customDataProperties?: Record<string, unknown>;
}

export type ContinuousScrollerSortDirection = 'ascending' | 'descending';

export interface ContinuousScrollerSort {
  scrollerId?: string | number;
  field: string;
  sortDirection: ContinuousScrollerSortDirection;
  sortPath?: string;
  order?: number;
  caseSensitive?: boolean;
  customDataProperties?: Record<string, unknown>;
}

export type ScrollerDataLoadInspectorFunction = (page: number, data: JsonData) => void;
export type ScrollerDataModificationFunction = (page: number, data: JsonData) => void;
export type ScrollerItemsChangedFunction = (data: JsonData) => void;
export type ScrollerChildRenderFunction = (
  data: JsonData,
  currentItemCount: number,
  page: number,
  isLastPage?: boolean
) => TypeOrArray<ReactNode>;
export type ScrollerDataItem = { __uniqueId?: string } & JsonDataItem;
export type ScrollerData = Array<ScrollerDataItem>;
